import { css } from '@emotion/css'

export const header = css`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 20px 0;
`

export const previewImg = css`
  max-width: 100px;
  max-height: 100px;
`